module.exports = __webpack_public_path__ + "static/media/firebase.84fc497f.png";